/**
 * Attribution API client.
 * Backend stores UTM params + metadata on the user record at signup.
 * Admin endpoints expose attribution data for analysis.
 */
import { apiGet, apiPost } from "./client.ts";

export interface AttributionData {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
  landing_variant?: string;
  referrer?: string;
}

export interface AttributionSummary {
  bySource: Array<{ source: string; signups: number; conversions: number }>;
  byCampaign: Array<{ campaign: string; signups: number; conversions: number }>;
  byVariant: Array<{ variant: string; signups: number; conversions: number }>;
  byReferrer: Array<{ referrer: string; signups: number }>;
}

export const attributionApi = {
  /** Attach attribution data to the current user (called once at signup). */
  track: (data: AttributionData) =>
    apiPost<{ ok: boolean }>("/attribution/track", data),

  /** Admin: get attribution data for a specific user. */
  forUser: (userId: string) =>
    apiGet<{ attribution: AttributionData | null }>(`/admin/attribution/users/${userId}`),

  /** Admin: get aggregated attribution summary. */
  summary: (params: { days?: number } = {}) => {
    const qs = params.days ? `?days=${params.days}` : "";
    return apiGet<AttributionSummary>(`/admin/attribution/summary${qs}`);
  },
};
